module.exports = __webpack_public_path__ + "static/media/03_05_05.989f3794.png";